"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var find_http_error_1 = require("../error/find-http-error");
var save_http_error_1 = require("../error/save-http-error");
var update_http_error_1 = require("../error/update-http-error");
var http_service_1 = require("./http.service");
var branch_1 = require("../model/branch");
var store_1 = require("@angular-redux/store");
var page_info_1 = require("../model/page-info");
var BranchService = /** @class */ (function () {
    function BranchService(_httpService, _ngRedux) {
        this._httpService = _httpService;
        this._ngRedux = _ngRedux;
        this.SAVE = BranchService.BRANCH_END_POINT + "/save";
        this.UPDATE = BranchService.BRANCH_END_POINT + "/update";
        this.FIND_BY_ID = BranchService.BRANCH_END_POINT + "/findById/";
        this.FIND_BY_NAME = BranchService.BRANCH_END_POINT + "/findByName/";
        this.FIND_BY_FILTER = BranchService.BRANCH_END_POINT + "/findByFilter/";
        this.FIND_PAGED_BRANCH = BranchService.BRANCH_END_POINT + "/findList/";
        this.FIND_PAGE_INFO = BranchService.BRANCH_END_POINT + "/findPageInfo/";
        this.saveSubject = new Subject_1.Subject();
        this.save$ = this.saveSubject.asObservable();
        this.updateSubject = new Subject_1.Subject();
        this.update$ = this.updateSubject.asObservable();
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.pageInfoSubject = new Subject_1.Subject();
        this.pageInfo$ = this.pageInfoSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    BranchService.prototype.save = function (branch) {
        var _this = this;
        this._httpService.post(this.SAVE, branch, branch_1.Branch, save_http_error_1.SaveHttpError)
            .subscribe(function (_branch) { return _this.saveSubject.next(_branch); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.prototype.update = function (branch) {
        var _this = this;
        this._httpService.put(this.UPDATE, branch, branch_1.Branch, update_http_error_1.UpdateHttpError)
            .subscribe(function (_branch) { return _this.updateSubject.next(_branch); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.prototype.findByName = function (name) {
        this.findByFilter({ name: name }, 0, 30);
    };
    BranchService.prototype.findById = function (id) {
        var _this = this;
        this._httpService.get("" + this.FIND_BY_ID + id, branch_1.Branch, find_http_error_1.FindHttpError)
            .subscribe(function (branch) { return _this.findSubject.next(branch); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.prototype.findBranches = function (pageNumber, pageSize) {
        var _this = this;
        this._ngRedux.select('branchFilter')
            .subscribe(function (filter) {
            _this.findByFilter(filter, pageNumber, pageSize);
            _this.findPageInfo(filter, pageSize);
        });
    };
    BranchService.prototype.findByPage = function (pageNumber, pageSize) {
        var _this = this;
        this._httpService.get("" + this.FIND_PAGED_BRANCH + pageNumber + "/" + pageSize, Array, find_http_error_1.FindHttpError)
            .subscribe(function (branches) { return _this.findSubject.next(branches); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.prototype.findPageInfo = function (filter, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_PAGE_INFO + "?pageSize=" + pageSize, filter, page_info_1.PageInfo, find_http_error_1.FindHttpError)
            .subscribe(function (pageInfo) { return _this.pageInfoSubject.next(pageInfo); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.prototype.findByFilter = function (filter, pageNumber, pageSize) {
        var _this = this;
        this._httpService.post(this.FIND_BY_FILTER + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize, filter, Array, find_http_error_1.FindHttpError)
            .subscribe(function (branches) { return _this.findSubject.next(branches); }, function (error) { return _this.errorSubject.next(error); });
    };
    BranchService.ctorParameters = function () { return [{ type: http_service_1.HttpService }, { type: store_1.NgRedux }]; };
    BranchService.BRANCH_END_POINT = '/branch';
    return BranchService;
}());
exports.BranchService = BranchService;
//# sourceMappingURL=branch.service.js.map


// WEBPACK FOOTER //
// branch.service.js